// extracted by mini-css-extract-plugin
export default {"successNotification":"SigningElectronicSignature_successNotification__dhoQs"};